import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import Fireflies from "./Fireflies";

const AboutCanvas = () => {
  return (
    <Suspense fallback={<span>loading...</span>}>
      <div style={{ position: "fixed", width: "100%", height: "100%" }}>
        <Canvas dpr={[1, 2]} camera={{ fov: 45, position: [-4, 2, -4] }}>
          <color attach="background" args={["#020c1b"]} />
          <Fireflies count={1000} />
        </Canvas>
      </div>
    </Suspense>
  );
};

export default AboutCanvas;
